// Imports

import { PortalContext } from "src/modules/01 Global/jsx/contexts.jsx";
import { gu_auth } from "src/lib/authentication.js";
import { StaffView } from "./staff-view.jsx";
import { SimulateSection } from "./simulate-section.jsx";
import { AttributesSection } from "./attributes-section.jsx";


// Stateful components

export class ToolsPanel extends React.Component{

    //
    // Lifecycle 
    //

    constructor(props) {
        super(props);

        this.state = {
            'is_open': false,
            'active_panel': '',
            'is_loading_user_data': false,
            'loading_sim_data_error': null
        };

        // Binds
        this.toggleOpenState = this.toggleOpenState.bind(this);
        this.toggleActivePanel = this.toggleActivePanel.bind(this);
        this.simulateUser = this.simulateUser.bind(this);
        this.clearSimulation = this.clearSimulation.bind(this);
        this.toggleStaffMode = this.toggleStaffMode.bind(this);
        this.simulateUserFailureCallback = this.simulateUserFailureCallback.bind(this);
        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    componentDidUpdate(prevProps, prevState) {
        if(prevState['is_loading_user_data'] === true) {
            this.setState({'is_loading_user_data': false});
        }
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    //
    // Events
    //

    setWrapperRef(node) {
        this.wrapperRef = node;
    }

    handleClickOutside(event) {
        if (this['state']['is_open']) {
            if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
                this.setState({ 'is_open': false });
            }
        }
    }

    toggleOpenState(event) {
        event.preventDefault();

        var this_component = this;
        var is_open = this_component['state']['is_open'];

        this_component.setState({
            'is_open': !is_open
        });
    }

    toggleActivePanel(event) {
        event.preventDefault();

        var this_component = this;
        var target_panel = event['target'].getAttribute('data-panel');

        this_component.setState({
            'active_panel': target_panel
        });
    }

    simulateUser(event) {
        // Prevent the page reloading when the form is submitted
        event.preventDefault();

        this.setState({'is_loading_user_data': true});

        // Clear any previous errors
        this.setState({ 'loading_sim_data_error': null });

        var s_number_input = document.querySelector('#simulate__snumber')

        if(s_number_input) {
            var s_number = s_number_input.value;

            gu_auth.fn.requestSimulationToken(s_number, this.simulateUserFailureCallback);
        }
    }

    simulateUserFailureCallback(response) {
        this.setState({'loading_sim_data_error': response});
    }

    clearSimulation() {

        this.setState({ 'is_loading_user_data': true });

        // Clear any previous errors
        this.setState({ 'loading_sim_data_error': null });

        gu_auth.fn.clearSimulationToken();
        
        setTimeout(function() {
            gu_auth['simulation']['callbacks'].clear(true);
        }, 1000); 
    }

    toggleStaffMode() {
        var this_component = this;
        var portal_context = this_component['context'];
        var helpers = portal_context['helpers'];
        helpers.toggleStaffMode();
    }


    //
    // Functions
    //

    


    //
    // Render
    //

    renderPanelState() {
        var this_component = this;
        var active_panel = this_component['state']['active_panel'];

        switch(active_panel) {
            case 'simulation':
            case 'attributes':
                return this_component.renderPanel(active_panel);
            default:
                return this_component.renderAvailableTools();
        }
    }

    renderPanel(panel) {
        var this_component = this;
        var clickHandler = this_component.toggleActivePanel;
        var back_label = 'Back';
        var panel_to_show = null;
        var callbacks = {};

        switch(panel) {
            case 'simulation':
                callbacks = {
                    'simulate': this_component.simulateUser,
                    'clear': this_component.clearSimulation
                };

                panel_to_show = <SimulateSection callbacks={callbacks} is_loading={this['state']['is_loading_user_data']} data_request_error={this['state']['loading_sim_data_error']}/>;
                break;
            case 'attributes':
                panel_to_show = <AttributesSection />
                break;
        }

        return (
            <div className="panel-section__wrapper">
                <button className="btn btn-secondary panel-tools__button" data-panel="" onClick={clickHandler}>{back_label}</button>
                <div className="panel-section">
                    {panel_to_show}
                </div>
            </div>
        );
    }

    renderAvailableTools() {
        var this_component = this;
        var portal_context = this_component['context'];
        var user_profile = portal_context['user_personalisation'];

        if(user_profile) {
            // Check which level of access the user has
            var can_simulate = gu_auth.fn.canSimulate(user_profile);
            var can_modify_attributes = gu_auth.fn.canModifyAttributes(user_profile);
            var can_access_staff_mode = gu_auth.fn.canAccessStaffMode(user_profile['attributes']);
            var clickHandler = this_component.toggleActivePanel;
            var staff_mode = portal_context['staff_mode'];

            return (
                <>
                    {can_access_staff_mode &&
                        <StaffView
                            handleToggle={this_component.toggleStaffMode}
                            active={staff_mode}
                        />
                    }
                    <ul className="panel-tools__list">
                        {can_simulate &&
                            <li className="panel-tools__item">
                                <button className="btn btn-primary panel-tools__button" data-panel="simulation" aria-label="Open user simulation" onClick={clickHandler}>Simulate user</button>
                            </li>
                        }
                        {can_modify_attributes &&
                            <li className="panel-tools__item">
                                <button className="btn btn-primary panel-tools__button" data-panel="attributes" aria-label="Open modify attributes section" onClick={clickHandler}>Modify attributes</button>
                            </li>
                        }
                    </ul>
                </>
            );
        }
        
        return null;
    }

    render() {
        var this_component = this;
        var portal_context = this_component['context'];
        var is_open = this_component['state']['is_open'];
        var clickHandler = this_component.toggleOpenState;
        var panel_state = this_component.renderPanelState();
        var icons = portal_context['configuration']['icons'];
        var icon_cog = {
            '__html': icons['cog']
        }
        
        return (
            <div ref={this.setWrapperRef} className="simulation-panel">
                {!is_open ? (
                   <button className="simulation-panel__icon simulation-panel__toggle" aria-label="Open staff tools" onClick={clickHandler} dangerouslySetInnerHTML={icon_cog}></button>
                ) : (
                    <div className="simulation-panel__dialogue">
                        <button className="simulation-panel__dialogue__back__button" onClick={clickHandler}>
                            <div className="simulation-panel__dialogue__back__button__icon"></div>
                            <div className="simulation-panel__dialogue__title">Staff Tools</div>
                        </button>
                        {panel_state}
                    </div>
                )}
            </div>
        );
    }

};

ToolsPanel.contextType = PortalContext;
